import script from "./followRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./followRecord.vue?vue&type=script&setup=true&lang=js"

import "./followRecord.vue?vue&type=style&index=0&id=acab5e72&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acab5e72"]])

export default __exports__